import styles from './UploadContracts.module.scss';

export const ImportHelp = () => (
  <aside className={styles.card} aria-labelledby="import-format-title">
    <h2 id="import-format-title">Formato del archivo</h2>
    <p>
      Incluye los encabezados en la primera fila. Se procesa únicamente la
      primera hoja; las demás se ignoran.
    </p>
    <dl className={styles.helpColumns}>
      <dt>A · Empleado</dt>
      <dd>Número de empleado registrado.</dd>
      <dt>B · Día</dt>
      <dd>De 0 (domingo) a 6 (sábado).</dd>
      <dt>C · Entrada / D · Salida</dt>
      <dd>
        Horario militar <strong>HHmm</strong>: horas <strong>00–23</strong> y
        minutos <strong>00–59</strong>. Ejemplos: <strong>0900</strong>,{' '}
        <strong>1700</strong>, <strong>0000</strong>. Los números{' '}
        <strong>900</strong> y <strong>0</strong> se normalizan a{' '}
        <strong>0900</strong> y <strong>0000</strong>.
      </dd>
      <dt>E · Contrato</dt>
      <dd>Código opcional; puede quedar vacío.</dd>
    </dl>
    <a
      className={styles.templateLink}
      href="/prosinergia-plantilla-subir-contratos.xlsx"
      download
    >
      Descargar plantilla
    </a>
  </aside>
);
